<template>
  <span>
    <template v-if="Array.isArray(config)">
      <form-control
        v-for="(btn, index) in config"
        :config="btn"
        :key="index"
        :index="index"
        @btnClick="(v) => $emit('btnClick', v)"
        @btnCancel="(v) => $emit('btnCancel', v)"
      />
    </template>
    <template v-else-if="visible && config">
      <v-text-field
        v-if="config.type === 'text'"
        v-model="model"
        :label="$t(config.label)"
        :rules="getValidationRules(config)"
        clearable
      ></v-text-field>
      <v-text-field
        v-else-if="config.type === 'multi'"
        v-model="model"
        :label="$t(config.label)"
        :rules="getValidationRules(config)"
        clearable
        multi-line
      ></v-text-field>
      <h3 v-else-if="config.type === 'title'" v-html="$t(config.label)" style="margin: 15px 0"></h3>
      <div v-else-if="config.type === 'html'" v-html="$t(config.label)"></div>
      <SignPad
        v-else-if="config.type === 'signpad'"
        :label="$t(config.label)"
        ref="attachment"
        :name="config.id"
      ></SignPad>
      <select-field
        v-else-if="config.type === 'select'"
        :id="config.id"
        :label="config.label"
        :rules="getValidationRules(config)"
        :options="config.options"
        :value="model || config.value"
        @input="setModel"
      />
      <tile-field
        v-else-if="config.type === 'tiles'"
        :options="config.options"
        :id="config.id"
        :value="model || config.value"
        :height="config.height"
        :width="config.width"
        @input="setModel"
        inline
      />
      <file-field
        v-else-if="config.type === 'file'"
        :id="config.id"
        :name="config.id"
        :label="config.label"
        :accept="config.accept"
        :multiple="config.multiple"
        @input="setModel"
      />
      <v-btn
        v-else-if="config.type === 'button'"
        :color="config.class"
        @click="() => $emit('btnClick', config)"
      >
        <v-icon v-if="config.icon">{{config.icon}}</v-icon>
        <span v-html="$t(config.label)"></span>
      </v-btn>
      <v-btn v-else-if="config.type === 'cancel'" @click="$emit('btnCancel', config)">
        <span>{{$t(config.label || 'Action.close')}}</span>
      </v-btn>

      <template v-else-if="config.type === 'row'">
        <v-layout row wrap>
          <v-flex v-for="(col, index) in config.items"
            :key="index"
            :class="[col.size ? `xs${col.size}` : 'xs12', col.class]"
          >
            <form-control
              v-for="(item, index) in col.items"
              :config="item"
              :key="index"
              :index="index"
              ref="controls"
              @btnClick="(v) => $emit('btnClick', v)"
              @btnCancel="(v) => $emit('btnCancel', v)"
            />
          </v-flex>
        </v-layout>
      </template>

      <template v-else-if="config.type === 'date'">
        <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="model"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-combobox
                v-model="model"
                :label="$t(config.label)"
                readonly
                v-bind="attrs"
                v-on="on"
            ></v-combobox>
          </template>
          <v-date-picker
              v-model="model"
              no-title
              scrollable
              @input="$refs.menu.save(model)"
          >
          </v-date-picker>
        </v-menu>
      </template>

      <template v-else>
        {{config}}
      </template>
    </template>
  </span>
</template>

<script>

import SignPad from './SignPad'

import SelectField from './SelectField';
import TileField from './TileField';
import FileField from './FileField';
// Select Box Control
// Tile picker (options images)

import RequiresResolver from '../mixins/RequiresResolver';

export default {
  name: 'FormControl',
  mixins: [RequiresResolver],
  components: {
    SignPad,
    SelectField,
    TileField,
    FileField,
  },
  props: {
    config: [Object, Array],
    index: Number,
  },

  data() {
    return {
      form: {},
      model: null
    }
  },

  mounted() {
    if (this.config.value) {
      this.model = this.config.value;
    }
  },

  computed: {
    controlKey() {
      return this.config.id || `__config${this.index}`;
    },
    visible() {
      return this.meetsRequirements(this.config)
    }
  },

  methods: {
    async getData() {

      if (['text', 'multi', 'tiles', 'select'].includes(this.config.type)) {
        return [{
          key: this.controlKey,
          value: this.model != null ? this.model : '',
        }]
      } else if (this.config.type === 'date') {
        return [{
          key: this.controlKey,
          value: this.model != null ? new Date(this.model).getTime() / 1000 : '',
        }]
      } else if (this.config.type === 'signpad') {
        const files = await this.$refs.attachment.files()
        console.log('Files', files)
        return files.map(({name, type, data}) => ({
          key: name,
          value: data,
          fileName: name
        }));
      } else if (this.config.type === 'file') {
        return (this.model || []).map(({name, data}) => {
          return {
            key: this.controlKey,
            value: data
          }
        })
      } else if (this.config.type === 'row') {
        let controls = Array.isArray(this.$refs.controls) && this.$refs.controls.length
          ? this.$refs.controls
          : [this.$refs.controls];

        return (await Promise.all(controls.map(control => control.getData())))
          .filter(_ => _)
          .reduce((p, c) => {
            p = p.concat(c)
            return p
          }, []);
      }
      return null;
    },
    getValidationRules({required}) {
      return [
        required && (v => !!v || 'Value is required'),
      ].filter(x => x)
    },
    setModel(v) {
      this.model = v;
    }
  }
}
</script>
